import React from "react";
import { ChannelEnum } from "../../constants/enums";
import WhatsAppChatPreview, {
  WhatsAppChatPreviewProps,
} from "./WhatsAppChatPreview";
import SmsChatPreview from "./SmsChatPreview";

export type MessagePreviewProps = WhatsAppChatPreviewProps;

const MessagePreview: React.FC<MessagePreviewProps> = (props) => {
  if (props.channel === ChannelEnum.Sms) {
    return <SmsChatPreview {...props} />;
  }
  return <WhatsAppChatPreview {...props} />;
};

export default MessagePreview;
